// src/app/services/currency.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Currency {
  code: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly apiUrl = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies.json';
  private readonly cacheCurrencies: Currency[] = [];


  constructor(private readonly http: HttpClient) { }

  getCurrencies(): Observable<Currency[]> {
    const cached = localStorage.getItem('currencies');
    if (cached) {
      const currencies: Currency[] = JSON.parse(cached);
      return new Observable((observer) => {
        observer.next(currencies);
        observer.complete();
      });
    }

    return new Observable((observer) => {
      this.http.get<{ [code: string]: string }>(this.apiUrl, { 
        headers: { 'Accept': 'application/json' }
      }).subscribe({
        next: (data) => {
          const currencies: Currency[] = Object.entries(data).map(([code, name]) => ({
            code,
            name: `${code} - ${name}`
          }));
          localStorage.setItem('currencies', JSON.stringify(currencies));
          observer.next(currencies);
          observer.complete();
        },
        error: (err) => observer.error(err)
      });
    });
  }
}
